import { useEffect, useState } from "react";
import { FaComments, FaTimes } from "react-icons/fa";
import "./ChatLauncher.css";

const GREETINGS = [
  "Hi 👋 I'm Techizen AI.\nTap me to chat!",
  "Looking for a programme?\nI can help you find one.",
  "Need fees or admission info?\nAsk me anything.",
];

export default function ChatLauncher({ isOpen, onToggleChat }) {
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (isOpen || dismissed) return undefined;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % GREETINGS.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [isOpen, dismissed]);

  // Auto-hide the greeting after a while so it never lingers over
  // page content on small screens.
  useEffect(() => {
    if (isOpen || dismissed) return undefined;

    const hide = setTimeout(() => setDismissed(true), 18000);

    return () => clearTimeout(hide);
  }, [isOpen, dismissed]);

  const showBubble = !isOpen && !dismissed;
  const greeting = GREETINGS[index].replace(/\n/g, " ");

  return (
    <div className="zety-launcher-wrap">
      {showBubble && (
        <div
          className="zety-launcher-bubble"
          role="status"
          aria-live="polite"
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              e.stopPropagation();
              setDismissed(true);
            }
          }}
        >
          <button
            type="button"
            className="zety-bubble-close"
            aria-label="Dismiss Techizen AI message"
            onClick={() => setDismissed(true)}
          >
            <FaTimes aria-hidden="true" />
          </button>

          <button
            type="button"
            className="zety-bubble-text"
            aria-label={`${greeting} Open the Techizen AI chat.`}
            aria-haspopup="dialog"
            aria-controls="techizen-chat-panel"
            onClick={onToggleChat}
          >
            {GREETINGS[index].split("\n").map((line) => (
              <span key={line}>{line}</span>
            ))}
          </button>
        </div>
      )}

      <button
        type="button"
        className={`zety-launcher ${isOpen ? "is-open" : ""}`}
        onClick={onToggleChat}
        aria-label={isOpen ? "Close Techizen AI chat" : "Chat with Techizen AI"}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        aria-controls="techizen-chat-panel"
        title={isOpen ? "Close Techizen AI chat" : "Chat with Techizen AI"}
      >
        <span className="zety-launcher-icon" aria-hidden="true">
          {isOpen ? <FaTimes /> : <FaComments />}
        </span>

        {!isOpen && <span className="zety-launcher-pulse" aria-hidden="true" />}
      </button>
    </div>
  );
}
